/**
 * Constantes globales de la aplicación ProCam360
 * Centraliza valores que se usan en múltiples componentes.
 * Las credenciales sensibles se leen desde variables de entorno (.env).
 */

// Número de WhatsApp (con código de país)
export const WHATSAPP_NUMBER =
  process.env.REACT_APP_WHATSAPP_NUMBER || '525522632166';

// URL del endpoint de Formspree para el formulario de contacto
export const FORMSPREE_URL =
  process.env.REACT_APP_FORMSPREE_URL || 'https://formspree.io/f/xdkzwwgv';

// Site key de Google reCAPTCHA v2
export const RECAPTCHA_SITEKEY =
  process.env.REACT_APP_RECAPTCHA_SITEKEY ||
  '6LeeIGsrAAAAAPMs73v10DHBZTkIR24_zkWGW77B';

/**
 * Genera el link de WhatsApp con mensaje preformateado.
 * @param {string} message - Mensaje que se enviará
 * @returns {string} URL completa de wa.me
 */
export const getWhatsAppUrl = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
